// extracted by css-extract-rspack-plugin
export default {"textButton":"mnU6LvR44XEIX4nD__textButton___","underline":"yfFk3OosyNchcZdw__underline___","bold":"L3sbB9dHktA7QABz__bold___","inheritSize":"bc89ClVBWy8uW8Pq__inheritSize___"};